import { useState } from 'react';
import PeoplePanel from '../PeoplePanel';
import { ActionBar, StepHeader, primaryBtn, secondaryBtn } from './ui';

/** Wizard step 4: name the people in the photos so the story can use their names. Optional. */
export default function PeopleStep({
  episodeId,
  onBack,
  onDone,
}: {
  episodeId: string;
  onBack: () => void;
  onDone: () => void;
}) {
  const [named, setNamed] = useState(0);
  return (
    <div>
      <StepHeader
        step={4}
        title="Who’s in these photos?"
        subtitle="Name the people you know, so the story can say “Ammi” instead of “everyone”. Skip anyone you like."
      />
      <PeoplePanel episodeId={episodeId} onNamedCount={setNamed} />
      <ActionBar>
        <button type="button" onClick={onBack} className={secondaryBtn}>
          Back
        </button>
        <button type="button" onClick={onDone} className={primaryBtn}>
          {named > 0 ? 'Next' : 'Skip for now'}
        </button>
      </ActionBar>
    </div>
  );
}
